// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/event.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ListAuditLogsRequest, ListAuditLogsResponse, WatchEventsRequest, WatchEventsResponse } from "./event_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.EventService
 */
export const EventService = {
  typeName: "gitpod.v1.EventService",
  methods: {
    /**
     * WatchEvents streams all requests events to the client
     *
     * @generated from rpc gitpod.v1.EventService.WatchEvents
     */
    watchEvents: {
      name: "WatchEvents",
      I: WatchEventsRequest,
      O: WatchEventsResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * ListAuditLogs retrieves a paginated list of audit logs for the specified organization
     *
     * @generated from rpc gitpod.v1.EventService.ListAuditLogs
     */
    listAuditLogs: {
      name: "ListAuditLogs",
      I: ListAuditLogsRequest,
      O: ListAuditLogsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

